/* eslint-disable prettier/prettier */
import React from "react";
import {
  AppBar,
  Toolbar,
  Container,
  Stack,
  Switch,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import TempleHinduIcon from "@mui/icons-material/TempleHindu";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import { Link } from "react-router-dom";
import MKBox from "../components/MKBox";
import MKButton from "../components/MKButton";
import translations from "../i18n/translations";
import { useLanguage } from "../context/LanguageContext";

function Navbar() {
  const { lang, setLang } = useLanguage();
  const toggleLanguage = () => setLang(prev => (prev === "en" ? "kn" : "en"));
  const t = translations[lang].navbar;

  return (
    <AppBar
      position="sticky"
      elevation={6}
      sx={{
        background: "linear-gradient(135deg, #d5af4c, #85730a, #b8860b)",
        borderBottom: "3px solid #8b6508",
      }}
    >
      <Toolbar>
        <Container maxWidth="lg">
          {/* ================= DESKTOP ================= */}
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <MKBox
              sx={{
                fontSize: 22,
                fontWeight: "bold",
                color: "#fff",
              }}
            >
              🛕 {t.title}
            </MKBox>

            <Stack direction="row" spacing={1.5} alignItems="center">
              <MKButton component={Link} to="/" sx={navButtonStyle}>
                {t.home}
              </MKButton>
              <MKButton component={Link} to="/hunnime-pooje" sx={navButtonStyle}>
                {t.pooje}
              </MKButton>
              <MKButton component={Link} to="/donations" sx={navButtonStyle}>
                {t.donations}
              </MKButton>

              {/* Desktop language */}
              <Typography fontSize={14} fontWeight="bold">English</Typography>
              <Switch
                checked={lang === "kn"}
                onChange={toggleLanguage}
                color="warning"
              />
              <Typography fontSize={14}fontWeight="bold">ಕನ್ನಡ</Typography>
            </Stack>
          </Box>

          {/* ================= MOBILE ================= */}
          <Box sx={{ display: { xs: "block", md: "none" } }}>
            {/* 🔹 Row 1: Title + Icons */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  fontWeight: "bold",
                  color: "#fff",
                  fontSize: 16,
                }}
              >
                🛕 {t.title}
              </Typography>

              <Stack direction="row" spacing={1}>
                <IconButton component={Link} to="/" sx={iconStyle}>
                  <HomeIcon />
                </IconButton>
                <IconButton
                  component={Link}
                  to="/hunnime-pooje"
                  sx={iconStyle}
                >
                  <TempleHinduIcon />
                </IconButton>
                <IconButton
                  component={Link}
                  to="/donations"
                  sx={iconStyle}
                >
                  <VolunteerActivismIcon />
                </IconButton>
              </Stack>
            </Box>

            {/* 🔹 Row 2: Language switch (FIXED INSIDE UI) */}
            <Box
              sx={{
                mt: 0.8,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "rgba(255,255,255,0.25)",
                borderRadius: "20px",
                px: 1.5,
                py: 0.3,
                width: "fit-content",
                mx: "auto",
              }}
            >
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: 11,
                  opacity: lang === "en" ? 1 : 0.5,
                }}
              >
                E
              </Typography>

              <Switch
                size="medium"
                checked={lang === "kn"}
                onChange={toggleLanguage}
                color="warning"
              />

              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: 11,
                  opacity: lang === "kn" ? 1 : 0.5,
                }}
              >
                ಕ
              </Typography>
            </Box>
          </Box>
        </Container>
      </Toolbar>
    </AppBar>
  );
}

/* ================= STYLES ================= */

const navButtonStyle = {
  background: "linear-gradient(135deg, #fff8dc, #ffd54f)",
  color: "#5d4037",
  fontWeight: "bold",
  borderRadius: "20px",
  px: 3,
  py: 1,
  textTransform: "none",
};

const iconStyle = {
  background: "#ffecb3",
  color: "#5d4037",
  width: 40,
  height: 40,
  borderRadius: "12px",
};

export default Navbar;
